import { get, map } from "utils/lodash";
import helper from "utils/helper";
import { lexicalToString } from "utils/lexicalFormatter";
import { format24h } from "utils/dateFormatter";
import { formatPrice } from "utils/currencyFormatter";

const StructuredData = ({
  type = "BeautySalon",
  shopData,
  reviews,
  totalReviews,
}: {
  type?: string;
  shopData: unknown;
  reviews: unknown[];
  totalReviews: number;
}) => {
  const pageSlug = get(shopData, "slug", "");
  const link = `${process.env.NEXT_PUBLIC_APP_URL}/${pageSlug}`;
  const bookingDayOfWeek = get(shopData, "bookingDayOfWeek", []);
  console.log(
    map(reviews, (review) => ({
      "@type": "Review",
      author: {
        "@type": "Person",
        name: get(review, "user.name", "Vô danh"),
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: get(review, "rating") || undefined,
        bestRating: 10,
      },
      reviewBody: get(review, "comment", ""),
      datePublished: get(review, "createdAt", ""),
    }))
  );
  const structuredData = {
    "@context": "https://schema.org",
    "@type": type,
    "@id": link,

    sameAs: [link],
    name: get(shopData, "name", ""),
    description: get(shopData, "description", "")
      ? lexicalToString(get(shopData, "description", ""))
      : "",
    url: link,
    image: helper.imageUrl(get(shopData, "avatar.url")),

    address:
      get(shopData, "displayedAddress") ??
      get(shopData, "oldStreetAddress") ??
      "",

    telephone: get(shopData, "phone", ""),
    // openingHours: [
    //   `${get(shopData, "openHour", "")} - ${get(shopData, "closeHour", "")}`,
    // ],

    // Geo coordinates
    geo: {
      "@type": "GeoCoordinates",
      latitude: get(shopData, "location.latitude", ""),
      longitude: get(shopData, "location.longitude", ""),
    },

    // Rating - Number format
    aggregateRating: {
      "@type": "AggregateRating",
      bestRating: 10,
      worstRating: 1,
      ratingValue: get(shopData, "rating"),
      ratingCount: totalReviews,
    },

    ...(get(shopData, "minPrice", "") && get(shopData, "maxPrice", "")
      ? {
          priceRange: `${formatPrice(
            get(shopData, "minPrice", "")
          )} - ${formatPrice(get(shopData, "maxPrice", ""))}`,
        }
      : {}),
    ...(reviews?.length > 0
      ? {
          review: map(reviews, (review) => ({
            "@type": "Review",
            author: {
              "@type": "Person",
              name: get(review, "user.name", "Vô danh"),
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: get(review, "rating") || undefined,
              bestRating: 10,
            },
            reviewBody: get(review, "comment", ""),
            datePublished: get(review, "createdAt", ""),
          })),
        }
      : {}),
    ...(bookingDayOfWeek?.length > 0
      ? {
          openingHoursSpecification: map(
            bookingDayOfWeek,
            (booking: {
              dayOfWeek: string;
              startTime: string;
              endTime: string;
            }) => ({
              "@type": "OpeningHoursSpecification",
              dayOfWeek: booking?.dayOfWeek,
              opens: format24h(booking?.startTime),
              closes: format24h(booking?.endTime),
            })
          ),
        }
      : {}),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData, null, 0),
      }}
    />
  );
};
export default StructuredData;
